import { useMemo } from 'react';

import moment from 'moment';

import LoanService from '../../services/LoanService';
import useForm from '../utils/useForm';

const useInvoiceForm = (onSubmit, values, loanId) => {
  const fields = useMemo(
    () => [
      {
        title: 'Create invoice',
        fields: [
          {
            title: 'Date',
            name: 'date',
            type: 'date',
            required: true,
          },
          {
            title: 'Status',
            name: 'status',
            type: 'select',
            options: [
              { value: 'pending', label: 'Pending' },
              { value: 'scheduled', label: 'Scheduled' },
              { value: 'open', label: 'Open' },
              { value: 'past due', label: 'Past due' },
              { value: 'due', label: 'Due' },
            ],
            required: true,
          },
          {
            title: 'Sequence',
            name: 'sequence',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['sequences', loanId],
              queryFn: async () => {
                try {
                  const sequences = await LoanService.getLoanSequences(loanId);

                  if (!sequences) {
                    return [];
                  }

                  const firstSequence = sequences[0];

                  if (!firstSequence) {
                    return [];
                  }

                  const zeroSequenceNumber = `${
                    firstSequence.sequence?.pixel_invoice_number?.split('-')[0]
                  }-0`;
                  const zeroDate = moment(firstSequence.sequence?.date)
                    .subtract(1, 'month')
                    .format('M/D/YY');

                  return [
                    {
                      sequence: {
                        sequence: 0,
                        date: zeroDate,
                        pixel_invoice_number: zeroSequenceNumber,
                      },
                    },
                    ...sequences,
                  ];
                } catch (error) {
                  console.log(error);
                  return [];
                }
              },
              labelKey: (item) => {
                return `${moment(item.sequence.date).format('M/D/YY')} | ${
                  item.sequence.pixel_invoice_number
                }`;
              },
              valueKey: 'sequence.sequence',
            },
            required: true,
          },
          {
            title: 'Type',
            name: 'type',
            type: 'select',
            options: [
              { value: 'S', label: 'Special' },
              { value: 'D', label: 'Blocking' },
            ],
            required: true,
          },
        ],
      },
    ],
    [loanId]
  );

  const { formik } = useForm({ fields, onSubmit, values });

  return { formik, fields, values };
};

export default useInvoiceForm;
